import { memo } from "react";
import { classNames } from "shared/lib/classNames/classNames";
import cls from "./SociometryClassInfo.module.scss";

interface SociometryClassInfoProps {
    classNumber: string;
    classLetter?: string;
    className?: string;
}

export const SociometryClassInfo = memo((props: SociometryClassInfoProps) => {
    const { classNumber, classLetter, className } = props;

    const classLabel = classLetter ? `${classNumber}${classLetter}` : classNumber;

    return (
        <div className={classNames(cls.sociometryClassInfo, {}, [className])}>
            <span className={cls.label}>Класс:</span>
            <span className={cls.value}>{classLabel}</span>
        </div>
    );
});

SociometryClassInfo.displayName = "SociometryClassInfo";
